"use client";

import { OptionType } from "@/components/select-multi";
import { AutocompleteProps } from "@/components/ui/autocomplete";
import { MultiSelect } from "@/components/ui/multi-select";
import { ProcedureValueResolver } from "@ept/shared/src/procedures";
import _ from "lodash";
import React from "react";
export type ReferenceResolverProps = {
  onValue: (option: {
    value: string;
  } | {
    value: string;
  }[]) => void;
  runningProcedureId?: string;
  isServant?: boolean;
  type: ProcedureValueResolver;
  referenceOptions: {
    value: string;
    label: string;
    type: "reference";
  }[];
} & Omit<AutocompleteProps, "options" | "onChange">;
export const ReferenceResolver = (props: ReferenceResolverProps) => {
  const [searchQuery, setSearchQuery] = React.useState("");
  const initialValue = props.initialValue ? Array.isArray(props.initialValue) ? props.initialValue : [props.initialValue] : null;
  const searchOptions = React.useMemo(() => {
    return props.referenceOptions.filter(option => option.label.toLowerCase().includes(searchQuery));
  }, [props.referenceOptions, searchQuery]);
  return <MultiSelect {...props} isServer selected={searchOptions.filter(option => initialValue?.includes(option.value))} options={searchOptions} onChange={option => props.onValue(option as OptionType[])} onQueryChange={setSearchQuery} data-sentry-element="MultiSelect" data-sentry-component="ReferenceResolver" data-sentry-source-file="ReferenceResolver.tsx" />;
};